const STORAGE_KEY = "postLoginRedirect";
const AUTH_PATHS = ["/sso", "/auth/"];
// SAML 2.0 bindings cap RelayState at 80 bytes; an IdP may reject longer values.
const MAX_RELAY_STATE_BYTES = 80;

export const safeRedirectPath = (value) => {
  if (typeof value !== "string") return null;
  const path = value.trim();
  if (!path.startsWith("/") || path.startsWith("//") || path.includes("\\")) {
    return null;
  }
  const pathname = path.split(/[?#]/)[0].toLowerCase();
  if (pathname === "/" || AUTH_PATHS.some((p) => pathname.startsWith(p))) {
    return null;
  }
  return path;
};

export const locationToPath = (location) => {
  if (!location || typeof location.pathname !== "string") return null;
  return safeRedirectPath(
    `${location.pathname}${location.search || ""}${location.hash || ""}`
  );
};

export const fitsRelayState = (path) =>
  // Each percent-escape from encodeURIComponent is one UTF-8 byte.
  encodeURIComponent(path).replace(/%[0-9A-F]{2}/g, "x").length <=
  MAX_RELAY_STATE_BYTES;

export const withRedirectParam = (url, path) => {
  const safe = safeRedirectPath(path);
  if (!safe) return url;
  const joiner = url.includes("?") ? "&" : "?";
  return `${url}${joiner}redirect=${encodeURIComponent(safe)}`;
};

export const rememberPostLoginRedirect = (path) => {
  const safe = safeRedirectPath(path);
  try {
    if (safe) sessionStorage.setItem(STORAGE_KEY, safe);
    else sessionStorage.removeItem(STORAGE_KEY);
  } catch {}
  return safe;
};

export const takePostLoginRedirect = () => {
  try {
    const value = sessionStorage.getItem(STORAGE_KEY);
    sessionStorage.removeItem(STORAGE_KEY);
    return safeRedirectPath(value);
  } catch {
    return null;
  }
};
